import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Container,
  Grid,
} from "@mui/material";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import { useNavigate } from "react-router-dom";
import ProductSelectDialog from "./../../components/ProductSelectDialog";
import { useProductsBranch } from "./../../hooks/useProductsBranch";
import PackDialog from "./../../components/PackDialog";
import * as services from "./../../services/saleng";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";

const buttonsTop = [
  // {
  //   label: "แพ็คสินค้า",
  //   icon: <MoveToInboxIcon fontSize="large" />,
  //   route: "",
  //   isDialog: true,
  // },
  {
    label: "รายการที่ยังไม่เข้าคลัง",
    icon: <LoopOutlinedIcon fontSize="large" />,
    route: "before_stock",
  },
  {
    label: "คลังสินค้า",
    icon: <Inventory2OutlinedIcon fontSize="large" />,
    route: "inventory",
  },
];

export default function Stock() {
  const navigate = useNavigate();
  const [openProdDialog, setOpenProdDialog] = useState(false);
  const [openPackDialog, setOpenPackDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { products } = useProductsBranch();

  const handleClick = (btn) => {
    if (btn.isDialog) setOpenProdDialog(true);
    else if (btn.external) window.open(btn.route, "_blank");
    else navigate(btn.route);
  };

  // ยิง API package (upsert)
  const handleCreateOrUpdatePackage = async (payload) => {
    const body = {
      productId: Number(payload.productId),
      type: String(payload.category || ""),
      quantity: Number(payload.net || 0),
      ...(payload?.id != null ? { id: Number(payload.id) } : {}),
    };
    return await services.upsertPackage(body);
  };

  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <AppBreadcrumbs />

      {/* หน้าตา/เลย์เอาต์ให้เหมือน HomePage ตัวอย่าง */}
      <Box
        minHeight="100vh"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          background: "linear-gradient(135deg, #e0f7fa, #ffffff)",
          px: 2,
        }}
      >

        <Container maxWidth="lg">
          {/* ปุ่ม grid */}
          <Grid container spacing={4} justifyContent="center">
            {buttonsTop.map((btn, index) => (
              <Grid item xs={12} sm={4} md={2} key={index}>
                <Box
                  onClick={() => handleClick(btn)}
                  sx={{ cursor: "pointer", textAlign: "center" }}
                >
                  <Paper
                    elevation={6}
                    sx={{
                      p: 3,
                      borderRadius: "50%",
                      backgroundColor: "#ffffff",
                      width: 120,
                      height: 120,
                      mx: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      transition: "all 0.3s",
                      ":hover": {
                        backgroundColor: "#185519",
                        color: "#fff",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <IconButton color="inherit" size="large">
                      {btn.icon}
                    </IconButton>
                  </Paper>
                  <Typography align="center" sx={{ mt: 2, fontWeight: "bold" }}>
                    {btn.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* เลือกสินค้า */}
      <ProductSelectDialog
        open={openProdDialog}
        onClose={() => {
          setOpenProdDialog(false);
        }}
        products={products}
        disabledProductIds={[]}
        onSelect={(prod) => {
          setSelectedProduct(prod);
          setOpenPackDialog(true);
        }}
      />

      {/* Dialog แพ็คสินค้า */}
      <PackDialog
        open={openPackDialog}
        onClose={() => setOpenPackDialog(false)}
        product={selectedProduct}
        onConfirm={async (payload) => {
          try {
            const res = await handleCreateOrUpdatePackage(payload);
            console.log("Package saved:", res?.data);
            setOpenProdDialog(false);
            setOpenPackDialog(false);
            toast.success("บันทึก Package สำเร็จ");
          } catch (err) {
            console.error("save package error:", err);
            toast.error("บันทึก Package ไม่สำเร็จ");
          }
        }}
      />
    </>
  );
}
